import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './shared/styles/AppDialog.css';
import './shared/utils/appDialog';
import App from './App';
import reportWebVitals from './reportWebVitals';

// export default function emptyCache(){
//   if('caches' in window){
//   caches.keys().then((names) => {
//           // Delete all the cache files
//           names.forEach(name => {
//               caches.delete(name);
//           })
//       });

//       // Makes sure the page reloads. Changes are only visible after you refresh.
//       window.location.reload();
//   }
// }

// emptyCache();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
